"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUserDetailRequest = instanceOfUserDetailRequest;
exports.UserDetailRequestFromJSON = UserDetailRequestFromJSON;
exports.UserDetailRequestFromJSONTyped = UserDetailRequestFromJSONTyped;
exports.UserDetailRequestToJSON = UserDetailRequestToJSON;
exports.UserDetailRequestToJSONTyped = UserDetailRequestToJSONTyped;
/**
 * Check if a given object implements the UserDetailRequest interface.
 */
function instanceOfUserDetailRequest(value) {
    if (!('password' in value) || value['password'] === undefined)
        return false;
    return true;
}
function UserDetailRequestFromJSON(json) {
    return UserDetailRequestFromJSONTyped(json, false);
}
function UserDetailRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'password': json['password'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
    };
}
function UserDetailRequestToJSON(json) {
    return UserDetailRequestToJSONTyped(json, false);
}
function UserDetailRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'password': value['password'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
    };
}
//# sourceMappingURL=userDetailRequest.js.map